/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_DescriptionInputs */

const en_landing_features_description = /** @type {(inputs: Landing_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-wired business logic so you can focus on building your product.`)
};

const zh_landing_features_description = /** @type {(inputs: Landing_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预置的业务逻辑，让你专注于产品本身。`)
};

/**
* | output |
* | --- |
* | "Pre-wired business logic so you can focus on building your product." |
*
* @param {Landing_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_description = /** @type {((inputs?: Landing_Features_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_description(inputs)
	return zh_landing_features_description(inputs)
});
export { landing_features_description as "landing.features.description" }